import { Component, Input, OnInit } from '@angular/core';
import { IEnvironmentDetails } from '../../interfaces/environment-details';

@Component({
  selector: 'app-review-selected-networks',
  templateUrl: './review-selected-networks.component.html',
  styleUrls: ['./review-selected-networks.component.sass']
})

export class ReviewSelectedNetworksComponent implements OnInit {

  @Input() selectedEnvironments: IEnvironmentDetails[];

  constructor() { }

  ngOnInit(): void {
  }

}
